export default __webpack_public_path__ + "static/media/CapaSetting.b6d720d5.svg";